import { Phone, Mail, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SITE } from "@/lib/site";
import { useSectionNav } from "@/lib/scroll";

export const Contact = () => {
  const goTo = useSectionNav();
  return (
    <section id="contact" className="section overflow-hidden" aria-labelledby="contact-title">
      <div className="container-x">
        <Reveal>
          <div className="relative overflow-hidden rounded-[2rem] border border-white/[0.08] bg-surface px-6 py-16 sm:px-12 sm:py-20 lg:px-20 text-center grain">
            <div className="absolute inset-0 bg-grid" aria-hidden="true" />
            <div className="orb left-1/2 -translate-x-1/2 -bottom-40 h-80 w-[640px] bg-indigo-600/25" aria-hidden="true" />
            <div className="relative">
              <p className="eyebrow">Contact</p>
              <h2 id="contact-title" className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white">Ready to Build Your Website?</h2>
              <p className="mt-4 text-base md:text-lg text-slate-400">Let's discuss your idea. We'll design it, build it, launch it — and take care of it as well.</p>

              <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-10">
                <a href={SITE.phoneHref} className="group flex items-center gap-3 text-white" data-testid="contact-phone-link">
                  <span className="grid h-11 w-11 place-items-center rounded-full border border-white/10 bg-white/[0.04] text-indigo-200 group-hover:bg-white/[0.08] transition-colors"><Phone className="h-4 w-4" aria-hidden="true" /></span>
                  <span className="text-left"><span className="block text-xs text-slate-500">Phone</span><span className="font-mono text-lg">{SITE.phone}</span></span>
                </a>
                <a href={SITE.emailHref} className="group flex items-center gap-3 text-white" data-testid="contact-email-link">
                  <span className="grid h-11 w-11 place-items-center rounded-full border border-white/10 bg-white/[0.04] text-indigo-200 group-hover:bg-white/[0.08] transition-colors"><Mail className="h-4 w-4" aria-hidden="true" /></span>
                  <span className="text-left"><span className="block text-xs text-slate-500">Email</span><span className="text-base sm:text-lg break-all">{SITE.email}</span></span>
                </a>
                <div className="flex items-center gap-3 text-white">
                  <span className="grid h-11 w-11 place-items-center rounded-full border border-white/10 bg-white/[0.04] font-mono text-[10px] text-indigo-200" aria-hidden="true">ABN</span>
                  <span className="text-left"><span className="block text-xs text-slate-500">ABN</span><span className="font-mono text-lg" data-testid="contact-abn">{SITE.abn}</span></span>
                </div>
              </div>

              <button onClick={() => goTo("quote")} className="btn-primary group mt-12 !min-h-[60px] !px-10 !text-lg" data-testid="contact-quote-btn">
                Get a Free Quote <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
